export default "__VITE_ASSET__D55j$E7D__"